export default __webpack_public_path__ + "static/media/template4.7bbfb4d7.png";